"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMunchkin = exports.onClickListener = exports.eventNames = exports.virtualPageView = exports.onPageLoadEvent = exports.oaAttribution = exports.oaga = void 0;
const Attribution_1 = require("./Legacy/Attribution");
const clickEvent_1 = require("./listeners/clickEvent");
const interactionCreatedEvent_1 = require("./listeners/customEvents/interactionCreatedEvent");
const leadCreatedEvent_1 = require("./listeners/customEvents/leadCreatedEvent");
class OAGA {
    constructor(page) {
        this.page = page;
        this.attribution = new Attribution_1.default();
    }
    setup() {
        (0, clickEvent_1.onClickEvents)(this.page);
        (0, interactionCreatedEvent_1.onInteractionEvent)(this.page);
        (0, leadCreatedEvent_1.onLeadCreatedEvent)(this.page);
        this.attribution.main();
    }
}
function oaga(options) {
    let page = options.page;
    let oaga = new OAGA(page);
    oaga.setup();
}
exports.oaga = oaga;
function oaAttribution() {
    return new Attribution_1.default();
}
exports.oaAttribution = oaAttribution;
var pageLoadEvents_1 = require("./listeners/pageLoadEvents");
Object.defineProperty(exports, "onPageLoadEvent", { enumerable: true, get: function () { return pageLoadEvents_1.onPageLoadEvent; } });
Object.defineProperty(exports, "virtualPageView", { enumerable: true, get: function () { return pageLoadEvents_1.virtualPageView; } });
var event_names_1 = require("./event.names");
Object.defineProperty(exports, "eventNames", { enumerable: true, get: function () { return event_names_1.eventNames; } });
var clickEvent_2 = require("./listeners/clickEvent");
Object.defineProperty(exports, "onClickListener", { enumerable: true, get: function () { return clickEvent_2.onClickListener; } });
var Vero_1 = require("./Legacy/Vero");
Object.defineProperty(exports, "getMunchkin", { enumerable: true, get: function () { return Vero_1.getMunchkin; } });
